import Months from "./months";
import * as moment from "moment";
import { getUserStatus } from "../../../redux/Actions/GetDocsActions";
import {
  getDemoSlots,
  clearDemoState,
  getDemoMonths,
  getDemoDays,
} from "../../../redux/Actions/SingleUserActions";
import { bookSlot } from "../../../redux/Actions/SingleUserActions";

export const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
  getSlots: (payload) => dispatch(getDemoSlots(payload)),
  getMonths: () => dispatch(getDemoMonths()),
  getDays: (payload) => dispatch(getDemoDays(payload)),
  chooseSlot: (payload) => dispatch(bookSlot(payload)),
  clearState: () => dispatch(clearDemoState()),
});

export const map_time = (time) => {
  if (time > 12) {
    return time - 12;
  } else {
    return time;
  }
};

export const map_date = (date) => {
  switch (true) {
    case date <= 11:
      return `am`;
    case date > 11:
      return `pm`;
    default:
      return date;
  }
};

export const removeCharacters = (str) => {
  let text = str
  text = text && text.slice(0, -3);
  return text
};

export function handleCalendar(
  setState,
  state,
  getDays,
  found,
  getSlots,
  type
) {
  return (event) => {
    let a = event.target.value;
    let [month, year] = a.split(/(\w+)$/);
    let monthName = month.replace(/,/g, "");
    setState({
      ...state,
      month: Months(monthName),
      year: year,
      monthName: event.target.value,
    });
    const payload = {
      month: Months(monthName),
      year: year,
      type: type,
    };
    getDays(payload);
    if (state.date !== "" && found === true) {
      const payload = {
        month: Months(monthName),
        day: state.date,
        year: year,
        type: type,
      };
      getSlots(payload);
    }
  };
}

export function handleSelection(setState, state, getSlots, type) {
  return (event) => {
    let date = event.target.value;
    setState({
      ...state,
      date: event.target.value,
    });
    if (state.month !== "") {
      const payload = {
        month: state.month,
        day: date,
        year: state.year,
        type: type,
      };
      getSlots(payload);
    }
  };
}

export function assignValues(appId, state, type, chooseSlot) {
  return () => {
    const payload = {
      application_id: appId,
      start_time: state.start_time && removeCharacters(state.start_time),
      end_time: state.end_time && removeCharacters(state.end_time),
      slot: state.slot,
      month: state.month,
      date: state.date,
      year: state.year,
      type: type,
    };
    chooseSlot(payload);
  };
}

export function confirmSection(state, setState) {
  return () => {
    let fullDate = moment(`${state.month}/${state.date}/${state.year}`).format(
      "dddd"
    );
    setState({
      ...state,
      show: !state.show,
      selectedDay: fullDate,
    });
  };
}

export default {
  map_time,
  map_date,
  handleCalendar,
  handleSelection,
  assignValues,
  confirmSection,
  mapDispatchToProps,
};
